import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import TressButton from "@/components/TressButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressBuyButton',
  emits: {
  click: (state: boolean) => {
    return true;
  },
},
  setup(__props, { emit }) {


const internalState = ref<boolean>(false);
const onClick = () => {
  internalState.value = true;
  setTimeout(() => {
    internalState.value = false;
  }, 3000);
  emit("click", internalState.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TressButton, { onClick: onClick }, {
    default: _withCtx(() => [
      (!internalState.value)
        ? _renderSlot(_ctx.$slots, "off", { key: 0 })
        : _renderSlot(_ctx.$slots, "on", { key: 1 })
    ]),
    _: 3
  }))
}
}

})